import { WeddingPartySection } from "../../types/wedding.party";
import { generateAPI } from "../api.generator";

export const getWeddingParty = generateAPI<
  {
    query: {
      weddingID: string;
    };
  },
  WeddingPartySection
>("get", "wedding-party/public/all");
